<ui-dialog
    #roeErrorModal
    header="employees.header.roeErrorModalHeader"
    size="small"
    secondaryButtonLabel="close"
    secondaryButtonType="primary"
    (closing)="roeErrorModal.open = false"
>
    <div [innerHTML]="'employees.header.roeErrorModalDescription' | appTranslate"></div>
</ui-dialog>

<!-- Body -->
<div class="ui basic segment" [class.loading]="isLoading">
    <app-header
        title="{{ 'payroll.roes.editRecordOfEmployment' | appTranslate }}"
        [back]="true"
        [backRoute]="['..']"
    ></app-header>

    <ng-container *ngIf="!!roe">
        <div class="ui segment">
            <app-segment-header title="{{ 'payroll.roes.employeeBlock' | appTranslate }}"></app-segment-header>
            <form class="ui static form">
                <div class="inline field">
                    <label>{{ 'payroll.roes.firstName' | appTranslate }}</label>
                    {{ roe.roeEmployee?.firstName }}
                </div>
                <div class="inline field">
                    <label>{{ 'payroll.roes.lastName' | appTranslate }}</label>
                    {{ roe.roeEmployee?.lastName }}
                </div>
                <div class="inline field">
                    <label>{{ 'payroll.roes.addressLine' | appTranslate }}</label>
                    {{ roe.roeEmployee?.addressLine1 }}
                </div>
                <div class="inline field">
                    <label>{{ 'payroll.roes.addressLine#462429' | appTranslate }}</label>
                    {{ roe.roeEmployee?.addressLine2 }}
                </div>
                <div class="inline field">
                    <label>{{ 'payroll.roes.postalCode' | appTranslate }}</label>
                    {{ roe.roeEmployee?.postalCode }}
                </div>
            </form>
        </div>

        <form #form="ngForm">
            <ui-card>
                <app-segment-header title="{{ 'payroll.roes.roeDatesBlocks' | appTranslate }}"></app-segment-header>
                <div class="app-grid">
                    <mat-form-field class="columns-6 small-columns-11">
                        <mat-label>{{ 'payroll.roes.firstDayWorked' | appTranslate }}</mat-label>
                        <input
                            matInput
                            name="firstDayWorked"
                            #firstDayWorked="ngModel"
                            [max]="roe.finalPayPeriodEndingDate"
                            [ngModel]="roe.firstDateWorked"
                            (ngModelChange)="updateInsurableEarnings($event, true)"
                            [matDatepicker]="firstDayWorkedDatePicker"
                        />
                        <mat-datepicker-toggle matSuffix [for]="firstDayWorkedDatePicker">
                            <mat-icon matDatepickerToggleIcon svgIcon="calendar"></mat-icon>
                        </mat-datepicker-toggle>
                        <mat-datepicker #firstDayWorkedDatePicker></mat-datepicker>
                    </mat-form-field>
                </div>

                <div class="app-grid">
                    <mat-form-field class="columns-6 small-columns-11">
                        <mat-label>{{ 'payroll.roes.lastDayOfWork' | appTranslate }}</mat-label>
                        <input
                            matInput
                            type="text"
                            placeholder="{{ 'payroll.roes.selectADate' | appTranslate }}"
                            #lastDayWorked="ngModel"
                            name="lastDayWorked"
                            [max]="roe.finalPayPeriodEndingDate"
                            [ngModel]="roe.lastDateForWhichPaid"
                            (ngModelChange)="updateInsurableEarnings($event, false)"
                            [matDatepicker]="lastDayWorkedDatePicker"
                        />
                        <mat-datepicker-toggle matSuffix [for]="lastDayWorkedDatePicker">
                            <mat-icon matDatepickerToggleIcon svgIcon="calendar"></mat-icon>
                        </mat-datepicker-toggle>
                        <mat-datepicker #lastDayWorkedDatePicker></mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="app-grid">
                    <mat-form-field class="columns-6 small-columns-11">
                        <mat-label>{{ 'payroll.roes.lastDayPeriodEndDate' | appTranslate }}</mat-label>
                        <input
                            matInput
                            type="text"
                            readonly
                            name="finalPayPeriodEndingDate"
                            #finalPayPeriodEndingDate="ngModel"
                            [(ngModel)]="roe.finalPayPeriodEndingDate"
                            [disabled]="true"
                        />
                    </mat-form-field>
                </div>
            </ui-card>

            <ui-card>
                <app-segment-header title="{{ 'payroll.roes.companyBlocks' | appTranslate }}"></app-segment-header>
                <div class="app-grid">
                    <mat-form-field class="columns-6 small-columns-11">
                        <mat-label>{{ 'payroll.roes.craBusinessNumber' | appTranslate }}</mat-label>
                        <input
                            matInput
                            type="text"
                            #craBusinessNumber="ngModel"
                            name="craBusinessNumber"
                            [(ngModel)]="roe.craPayrollAccount.registrationNumber"
                        />
                        <mat-error *ngIf="craBusinessNumber.invalid">{{
                            craBusinessNumber.errors | formErrors
                        }}</mat-error>
                    </mat-form-field>
                </div>
                <div class="app-grid">
                    <mat-form-field class="columns-6 small-columns-11">
                        <mat-label>{{ 'payroll.roes.craPayrollAccount' | appTranslate }}</mat-label>
                        <input
                            matInput
                            type="text"
                            #payrollProgramIdentifier="ngModel"
                            name="payrollProgramIdentifier"
                            [(ngModel)]="roe.craPayrollAccount.identifier"
                        />
                        <mat-error *ngIf="payrollProgramIdentifier.invalid">{{
                            payrollProgramIdentifier.errors | formErrors
                        }}</mat-error>
                    </mat-form-field>
                </div>
                <div class="app-grid">
                    <mat-form-field class="columns-6 small-columns-11">
                        <mat-label>{{ 'payroll.roes.payPeriodType' | appTranslate }}</mat-label>
                        <input
                            matInput
                            type="text"
                            readonly
                            name="payPeriodType"
                            #payPeriodType="ngModel"
                            [ngModel]="roe.payPeriodType | titlecase"
                            (ngModelChange)="roe.payPeriodType = $event"
                            [disabled]="true"
                        />
                    </mat-form-field>
                </div>
            </ui-card>

            <ui-card>
                <app-segment-header title="{{ 'payroll.roes.roeBlocksA' | appTranslate }}"></app-segment-header>

                <div class="app-grid">
                    <mat-form-field class="columns-6 small-columns-11">
                        <mat-label appRemoveAriaOwns>{{ 'payroll.roes.expectedRecall' | appTranslate }}</mat-label>
                        <mat-select
                            name="expectedRecall"
                            placeholder="{{ 'payroll.roes.pleaseSelect' | appTranslate }}"
                            #expectedRecall="ngModel"
                            [(ngModel)]="roe.expectedRecall.code"
                            (ngModelChange)="toggleRecallDateValue()"
                        >
                            <mat-option value="Y">{{ 'payroll.roes.expectedDateOfRecall' | appTranslate }}</mat-option>
                            <mat-option value="U">{{ 'payroll.roes.unknown' | appTranslate }}</mat-option>
                            <mat-option value="N">{{ 'payroll.roes.notReturning' | appTranslate }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-error *ngIf="expectedRecall.invalid">{{ expectedRecall.errors | formErrors }}</mat-error>
                </div>
                <div class="app-grid" *ngIf="roe.recallCodeIsY()">
                    <mat-form-field class="columns-6 small-columns-11">
                        <mat-label>{{ 'payroll.roes.recallDate' | appTranslate }}</mat-label>
                        <input
                            matInput
                            name="recallDate"
                            #recallDate="ngModel"
                            [(ngModel)]="roe.expectedRecall.date"
                            [matDatepicker]="recallDatePicker"
                        />
                        <mat-datepicker-toggle matSuffix [for]="recallDatePicker">
                            <mat-icon matDatepickerToggleIcon svgIcon="calendar"></mat-icon>
                        </mat-datepicker-toggle>
                        <mat-datepicker #recallDatePicker></mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="app-grid">
                    <mat-form-field class="columns-6 small-columns-11">
                        <mat-label>{{ 'payroll.roes.totalInsurableHours' | appTranslate }}</mat-label>
                        <input
                            matInput
                            type="text"
                            name="totalInsurableHours"
                            #totalInsurableHours="ngModel"
                            [(ngModel)]="roe.totalInsurableHours"
                        />
                    </mat-form-field>
                    <mat-error *ngIf="totalInsurableHours.invalid">{{
                        totalInsurableHours.errors | formErrors
                    }}</mat-error>
                </div>
                <div class="app-grid">
                    <mat-form-field class="columns-6 small-columns-11">
                        <mat-label appRemoveAriaOwns>{{ 'payroll.roes.reasonForIssuingRoe' | appTranslate }}</mat-label>
                        <mat-select
                            name="roeIssuingReason"
                            placeholder="{{ 'payroll.roes.pleaseSelect' | appTranslate }}"
                            #roeIssuingReason="ngModel"
                            [(ngModel)]="roe.reasonForIssuing.separationCode"
                        >
                            <mat-option *ngFor="let option of roeIssuingReasonOptions" [value]="option.value">{{
                                option.label
                            }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-error *ngIf="roeIssuingReason.invalid">{{ roeIssuingReason.errors | formErrors }}</mat-error>
                </div>
                <div class="app-grid">
                    <mat-form-field class="columns-6 small-columns-11">
                        <mat-label>{{ 'payroll.roes.comments' | appTranslate }}</mat-label>
                        <input
                            matInput
                            type="text"
                            name="commentsBlock"
                            #commentsBlock="ngModel"
                            [(ngModel)]="roe.comments"
                            maxlength="160"
                        />
                    </mat-form-field>
                    <p class="columns-6 small-columns-11 margin-top-2">
                        {{ 'payroll.roes.ifIncludeComment' | appTranslate }}
                        <a
                            href="https://www.canada.ca/en/employment-social-development/programs/ei/ei-list/reports/roe-guide/instructions.html#block18"
                            target="_blank"
                            >{{ 'payroll.roes.moreDetails' | appTranslate }}</a
                        >
                    </p>
                </div>
            </ui-card>

            <ui-card>
                <app-segment-header title="{{ 'payroll.roes.companysRoeContact' | appTranslate }}"></app-segment-header>
                <ui-banner *ngIf="isPlaceholderValues" variant="warning" class="margin-bottom-3">
                    <div [innerHTML]="{ key: 'payroll.roes.roeContactWarningBanner' } | appTranslate"></div>
                </ui-banner>
                <div class="app-grid">
                    <mat-form-field class="columns-6 small-columns-11">
                        <mat-label>{{ 'payroll.roes.firstName' | appTranslate }}</mat-label>
                        <input
                            matInput
                            type="text"
                            name="firstName"
                            #firstName="ngModel"
                            [(ngModel)]="roe.reasonForIssuing.contact.firstName"
                        />
                    </mat-form-field>
                    <mat-error *ngIf="firstName.invalid">{{ firstName.errors | formErrors }}</mat-error>
                </div>
                <div class="app-grid">
                    <mat-form-field class="columns-6 small-columns-11">
                        <mat-label>{{ 'payroll.roes.lastName' | appTranslate }}</mat-label>
                        <input
                            matInput
                            type="text"
                            name="lastName"
                            #lastName="ngModel"
                            [(ngModel)]="roe.reasonForIssuing.contact.lastName"
                        />
                    </mat-form-field>
                    <mat-error *ngIf="lastName.invalid">{{ lastName.errors | formErrors }}</mat-error>
                </div>
                <div class="app-grid">
                    <mat-form-field class="columns-6 small-columns-11">
                        <mat-label>{{ 'payroll.roes.areaCode' | appTranslate }}</mat-label>
                        <input
                            matInput
                            type="text"
                            name="areaCode"
                            #areaCode="ngModel"
                            [(ngModel)]="roe.reasonForIssuing.contact.areaCode"
                        />
                    </mat-form-field>
                    <mat-error *ngIf="areaCode.invalid">{{ areaCode.errors | formErrors }}</mat-error>
                </div>
                <div class="app-grid">
                    <mat-form-field class="columns-6 small-columns-11">
                        <mat-label>{{ 'payroll.roes.phoneNumber' | appTranslate }}</mat-label>
                        <input
                            matInput
                            type="text"
                            name="phoneNumber"
                            #phoneNumber="ngModel"
                            [(ngModel)]="roe.reasonForIssuing.contact.phoneNumber"
                        />
                    </mat-form-field>
                    <mat-error *ngIf="phoneNumber.invalid">{{ phoneNumber.errors | formErrors }}</mat-error>
                </div>
                <div class="app-grid">
                    <mat-form-field class="columns-6 small-columns-11">
                        <mat-label>{{ 'payroll.roes.phoneNumberExtension' | appTranslate }}</mat-label>
                        <input
                            matInput
                            type="text"
                            name="phoneNumberExtension"
                            #phoneNumberExtension="ngModel"
                            [(ngModel)]="roe.reasonForIssuing.contact.phoneExtensionNumber"
                        />
                    </mat-form-field>
                    <mat-error *ngIf="phoneNumberExtension.invalid">{{
                        phoneNumberExtension.errors | formErrors
                    }}</mat-error>
                </div>
            </ui-card>

            <ui-card>
                <app-segment-header
                    title="{{ 'payroll.roes.perperiodInsurableEarningsBlockC' | appTranslate }}"
                ></app-segment-header>
                <table class="ui table">
                    <thead>
                        <tr>
                            <th>{{ 'payroll.roes.startDate' | appTranslate }}</th>
                            <th>{{ 'payroll.roes.endDate' | appTranslate }}</th>
                            <th>{{ 'payroll.roes.amount' | appTranslate }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let payPeriod of roe.payPeriods; let i = index">
                            <td>
                                <div class="ui input">{{ payPeriod.startDate }}</div>
                            </td>
                            <td>
                                <div class="ui input">{{ payPeriod.endDate }}</div>
                            </td>
                            <td>
                                <div class="app-grid">
                                    <mat-form-field class="columns-6 small-columns-11">
                                        <input
                                            matInput
                                            type="text"
                                            name="insurableEarningsAmount-{{ i }}"
                                            #insurableEarningsAmount="ngModel"
                                            [ngModel]="getInsurableAmountByPayPeriodNumber(payPeriod.number).amount"
                                            (ngModelChange)="
                                                getInsurableAmountByPayPeriodNumber(payPeriod.number).amount = $event
                                            "
                                        />
                                    </mat-form-field>
                                    <mat-error *ngIf="insurableEarningsAmount.invalid">{{
                                        insurableEarningsAmount.errors | formErrors
                                    }}</mat-error>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </ui-card>

            <ui-card>
                <app-segment-header title="{{ 'payroll.roes.vacationPayBlockA' | appTranslate }}"></app-segment-header>

                <div class="app-grid">
                    <mat-form-field class="columns-6 small-columns-11">
                        <mat-label appRemoveAriaOwns>{{ 'payroll.roes.code' | appTranslate }}</mat-label>
                        <mat-select
                            name="vacationPayCode"
                            vacationPayCode
                            #vacationPayCode="ngModel"
                            [(ngModel)]="roe.vacationPay.code"
                        >
                            <mat-option value="">{{ 'payroll.roes.none' | appTranslate }}</mat-option>
                            <mat-option value="1">{{ 'payroll.roes.includedWithEachPay' | appTranslate }}</mat-option>
                            <mat-option value="2">{{
                                'payroll.roes.paidBecauseNoLongerWorking' | appTranslate
                            }}</mat-option>
                            <mat-option value="3">{{
                                'payroll.roes.paidForAvacationLeavePeriod' | appTranslate
                            }}</mat-option>
                            <mat-option value="4">{{
                                'payroll.roes.anniversaryPaidOnAspecificDateEachYear' | appTranslate
                            }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-error *ngIf="vacationPayCode.invalid">{{ vacationPayCode.errors | formErrors }}</mat-error>
                </div>
                <div class="app-grid">
                    <mat-form-field class="columns-6 small-columns-11">
                        <mat-label>{{ 'payroll.roes.amount' | appTranslate }}</mat-label>
                        <input
                            matInput
                            type="text"
                            name="vacationPayAmount"
                            #vacationPayAmount="ngModel"
                            [(ngModel)]="roe.vacationPay.amount"
                        />
                    </mat-form-field>
                    <mat-error *ngIf="vacationPayAmount.invalid">{{ vacationPayAmount.errors | formErrors }}</mat-error>
                </div>
            </ui-card>

            <ui-card>
                <app-segment-header
                    title="{{ 'payroll.roes.statutoryHolidayPaysBlockB' | appTranslate }}"
                ></app-segment-header>
                <table class="ui table">
                    <thead>
                        <tr>
                            <th>{{ 'payroll.roes.date' | appTranslate }}</th>
                            <th>{{ 'payroll.roes.amount' | appTranslate }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let statutoryHoliday of roe.statutoryHolidays; let i = index">
                            <td>
                                <div class="app-grid">
                                    <mat-form-field class="columns-6 small-columns-11">
                                        <input
                                            matInput
                                            name="statutoryHolidayDate-{{ i }}"
                                            #statutoryHolidayDate="ngModel"
                                            [(ngModel)]="statutoryHoliday.date"
                                            [matDatepicker]="statutoryHolidayDatePicker"
                                        />
                                        <mat-datepicker-toggle matSuffix [for]="statutoryHolidayDatePicker">
                                            <mat-icon matDatepickerToggleIcon svgIcon="calendar"></mat-icon>
                                        </mat-datepicker-toggle>
                                        <mat-datepicker #statutoryHolidayDatePicker></mat-datepicker>
                                    </mat-form-field>
                                </div>
                            </td>
                            <td>
                                <div class="app-grid">
                                    <mat-form-field class="columns-6 small-columns-11">
                                        <input
                                            matInput
                                            type="number"
                                            name="statutoryHolidayAmount-{{ i }}"
                                            #statutoryHolidayAmount="ngModel"
                                            [(ngModel)]="statutoryHoliday.amount"
                                        />
                                    </mat-form-field>
                                    <mat-error *ngIf="statutoryHolidayAmount.invalid">{{
                                        statutoryHolidayAmount.errors | formErrors
                                    }}</mat-error>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </ui-card>

            <ui-card>
                <app-segment-header title="{{ 'payroll.roes.otherMoniesBlockC' | appTranslate }}"></app-segment-header>
                <table class="ui table">
                    <thead>
                        <tr>
                            <th>{{ 'payroll.roes.code' | appTranslate }}</th>
                            <th>{{ 'payroll.roes.amount' | appTranslate }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let otherMoney of roe.otherMonies; let i = index">
                            <td>
                                <div class="app-grid">
                                    <mat-form-field class="columns-6 small-columns-11">
                                        <mat-select
                                            name="otherMoneyCode"
                                            placeholder="{{ 'payroll.roes.pleaseSelect' | appTranslate }}"
                                            name="otherMoneyCode-{{ i }}"
                                            #otherMoneyCode="ngModel"
                                            [(ngModel)]="otherMoney.code"
                                        >
                                            <mat-option value="B05">{{
                                                'payroll.roes.bonusHoliday' | appTranslate
                                            }}</mat-option>
                                            <mat-option value="B06">{{
                                                'payroll.roes.bonusProductionIncentive' | appTranslate
                                            }}</mat-option>
                                            <mat-option value="B07">{{
                                                'payroll.roes.bonusEvent' | appTranslate
                                            }}</mat-option>
                                            <mat-option value="B08">{{
                                                'payroll.roes.bonusStayingContractCompleteEndOfSeason' | appTranslate
                                            }}</mat-option>
                                            <mat-option value="B09">{{
                                                'payroll.roes.bonusSeparationOrRetirement' | appTranslate
                                            }}</mat-option>
                                            <mat-option value="B10">{{
                                                'payroll.roes.bonusClosure' | appTranslate
                                            }}</mat-option>
                                            <mat-option value="B11">{{
                                                'payroll.roes.bonusOther' | appTranslate
                                            }}</mat-option>
                                            <mat-option value="E00">{{
                                                'payroll.roes.severancePay' | appTranslate
                                            }}</mat-option>
                                            <mat-option value="G00">{{
                                                'payroll.roes.gratuities' | appTranslate
                                            }}</mat-option>
                                            <mat-option value="H00">{{
                                                'payroll.roes.honorariums' | appTranslate
                                            }}</mat-option>
                                            <mat-option value="I00">{{
                                                'payroll.roes.sickLeaveCredits' | appTranslate
                                            }}</mat-option>
                                            <mat-option value="J00">{{
                                                'payroll.roes.retroactivePayAdjustment' | appTranslate
                                            }}</mat-option>
                                            <mat-option value="O00">{{
                                                'payroll.roes.other' | appTranslate
                                            }}</mat-option>
                                            <mat-option value="Q00">{{
                                                'payroll.roes.profitSharing' | appTranslate
                                            }}</mat-option>
                                            <mat-option value="R00">{{
                                                'payroll.roes.retiringAllowanceRetirementLeaveCredits' | appTranslate
                                            }}</mat-option>
                                            <mat-option value="S00">{{
                                                'payroll.roes.settlementPay' | appTranslate
                                            }}</mat-option>
                                            <mat-option value="T00">{{
                                                'payroll.roes.payoutOfBankedOvertime' | appTranslate
                                            }}</mat-option>
                                            <mat-option value="Y00">{{
                                                'payroll.roes.payInLieuOfNotice' | appTranslate
                                            }}</mat-option>
                                            <mat-option value="U12">{{
                                                'payroll.roes.subMaternityParentalCompassionateCareFamilyCaregiver'
                                                    | appTranslate
                                            }}</mat-option>
                                            <mat-option value="U13">{{
                                                'payroll.roes.subLayoff' | appTranslate
                                            }}</mat-option>
                                            <mat-option value="U14">{{
                                                'payroll.roes.subIllness' | appTranslate
                                            }}</mat-option>
                                            <mat-option value="U15">{{
                                                'payroll.roes.subTraining' | appTranslate
                                            }}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <mat-error *ngIf="otherMoneyCode.invalid">{{
                                        otherMoneyCode.errors | formErrors
                                    }}</mat-error>
                                </div>
                            </td>
                            <td>
                                <div class="app-grid">
                                    <mat-form-field class="columns-6 small-columns-11">
                                        <input
                                            matInput
                                            type="number"
                                            name="otherMoneyAmount-{{ i }}"
                                            #otherMoneyAmount="ngModel"
                                            [(ngModel)]="otherMoney.amount"
                                        />
                                    </mat-form-field>
                                    <mat-error *ngIf="otherMoneyAmount.invalid">{{
                                        otherMoneyAmount.errors | formErrors
                                    }}</mat-error>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </ui-card>

            <ui-card>
                <app-segment-header
                    title="{{ 'payroll.roes.specialPaymentsBlock' | appTranslate }}"
                ></app-segment-header>
                <table class="ui table">
                    <thead>
                        <tr>
                            <th>{{ 'payroll.roes.code' | appTranslate }}</th>
                            <th>{{ 'payroll.roes.amount' | appTranslate }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let specialPayment of roe.specialPayments; let i = index">
                            <td>{{ specialPayment.code }}</td>
                            <td>
                                <div class="app-grid">
                                    <mat-form-field class="columns-6 small-columns-11">
                                        <input
                                            matInput
                                            type="number"
                                            name="specialPaymentAmount-{{ i }}"
                                            #specialPaymentAmount="ngModel"
                                            [(ngModel)]="specialPayment.amount"
                                        />
                                    </mat-form-field>
                                    <mat-error *ngIf="specialPaymentAmount.invalid">{{
                                        specialPaymentAmount.errors | formErrors
                                    }}</mat-error>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </ui-card>

            <ui-card>
                <ui-button type="primary" style="float: right" (click)="onSave()">{{
                    'payroll.roes.save' | appTranslate
                }}</ui-button>
                <ui-button type="ghost" (click)="onCancel()" style="float: right; margin-right: 10px">{{
                    'payroll.roes.cancel' | appTranslate
                }}</ui-button>
                <div class="clear"></div>
            </ui-card>
        </form>
    </ng-container>
</div>
